import React, {ReactElement} from 'react';
import AssignmentIcon from '@material-ui/icons/Assignment';

interface DocFileComponentProps {
  className: any;
  avatarClassName: any;
  fileName: any;
  fileNameClass: any;
}

const DocFileComponent = (props: DocFileComponentProps): ReactElement => {
  const {className, avatarClassName, fileName, fileNameClass} = props;

  return (
    <div className={className}>
      <AssignmentIcon className={avatarClassName} />
      <div className={fileNameClass}>{fileName}</div>
    </div>
  );
};

export default DocFileComponent;
